import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import logo from './logo.svg';
import './App.css';
import Blog from './blog/Blog';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import AppTheme from './shared-theme/AppTheme';
import AppAppBar from './AppAppBar';
import Footer from './Footer';
import Home from './home/Home';
import Legislation from './legislation/Legislation';
import About from './about/About';
import Contact from './contact/Contact';
import { apiv1 } from './api/apiv1';

export const GROUP_NAME = "Constitutional Civil Rights Accountability Initiative"
export const GROUP_URL = "https://ccrai.org";

function MissingPage() {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <h1>Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
      <p>You can return to the <a href="/">home page</a> or click the links in the navigation bar.</p>
    </Container>
  )
}

function App() {
  // Redirect to ccrai.org if accessing from a different domain
  useEffect(() => {
    const currentOrigin = window.location.origin;
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    const currentHash = window.location.hash;   const targetOrigin = "https://ccrai.org";

    const hit = `${currentOrigin}${currentPath}${currentSearch}${currentHash}`;

    apiv1.hitCounter(hit).finally(() => {
      // Only redirect if:
      // 1. We're not already on ccrai.org
      // 2. We're not on localhost (for development)
      // 3. We're not on a development/staging domain
      if (
        currentOrigin !== targetOrigin && 
        !window.location.hostname.includes('localhost') &&
        !window.location.hostname.includes('127.0.0.1') &&
        !window.location.hostname.includes('.local') &&
        window.location.hostname !== 'ccrai.org'
      ) {
        // Preserve the current path and search params
        
        // Construct the new URL
        const newUrl = `${targetOrigin}${currentPath}${currentSearch}${currentHash}`;
        
        console.log(`Redirecting from ${currentOrigin} to ${newUrl}`);
        
        // Perform the redirect
        window.location.replace(newUrl);
        return;
      }
    })
  }, []);

  return (
    <div className="App">
      <AppTheme>
        <CssBaseline enableColorScheme />
        <Router>
          <AppAppBar />
          <Container
            maxWidth="lg"
            component="main"
            sx={{ display: 'flex', flexDirection: 'column', my: 16, gap: 4 }}
          >
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/legislation" element={<Legislation />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/qr-lander" element={<Navigate to="/" replace />} />
              <Route path="*" element={<MissingPage />} />
            </Routes>
          </Container>
          <Footer />
        </Router>
      </AppTheme>
    </div>
  );
}

export default App;
